import { render, staticRenderFns } from "./historyshoyi.vue?vue&type=template&id=295b8976&scoped=true"
import script from "./historyshoyi.vue?vue&type=script&lang=js"
export * from "./historyshoyi.vue?vue&type=script&lang=js"
import style0 from "./historyshoyi.vue?vue&type=style&index=0&id=295b8976&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295b8976",
  null
  
)

export default component.exports